module.exports = __webpack_public_path__ + "media/images/icon_keyboard_shortcuts-4b183486762cfcc9f0de7522520a5485.png";